/* ============================================================
   Fills — reveal-on-scroll sutil para todo el sitio.
   Elementos clave aparecen con un fade + leve subida al entrar en
   viewport (escalonado por hermanos). Se autodesactiva con
   prefers-reduced-motion. Si el JS no corre, todo es visible.
   ============================================================ */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Selectores de elementos a revelar (tarjetas, titulares, media, stats…).
  var SEL = [
    '.fills-fc2__card', '.fills-bb3__panel', '.fills-sci__media', '.fills-sci__copy', '.fills-sci__stat',
    '.fills-q2__bullet', '.fills-q2__gummy', '.fills-vfaq__card', '.fills-cmp2__scroll',
    '.fills-tst2__card', '.fills-tl2__step', '.fills-tl2__note', '.fills-faq2__item', '.fills-faq2__media',
    '.fills-bcards__card', '.fills-art__rcard', '.fills-blog__card', '.fills-blog__feature',
    '.fills-stat', '.fills-myth__card', '.fills-mitos__card', '.fills-bars', '.fills-key',
    '[data-section-type] h2', '.fills-art__cta', '.fills-blog__silos'
  ].join(',');

  function init() {
    var els = Array.prototype.slice.call(document.querySelectorAll(SEL));
    if (!els.length || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('fills-anim');

    els.forEach(function (el) {
      el.classList.add('fills-reveal');
      // Escalona por posición entre hermanos para un efecto en cascada suave.
      var i = 0, p = el.previousElementSibling;
      while (p && i < 4) { if (p.classList && p.classList.contains('fills-reveal')) i++; p = p.previousElementSibling; }
      if (i) el.style.setProperty('--reveal-delay', (i * 55) + 'ms');
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
